module.exports = __webpack_public_path__ + "public/images/schedule/schedule-list.fa17e0bd2b9409412d8fb566d18fd988.svg";